/* NAO Upgrade Kit — motion & interactions (no dependencies) */
(function () {
  'use strict';
  var doc = document.documentElement;
  doc.classList.add('nao-js');
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var cfg = window.NAO_UPGRADE || {};

  /* ---------- Count-up ---------- */
  function fmt(n, dec) {
    return n.toLocaleString('en-US', { minimumFractionDigits: dec, maximumFractionDigits: dec });
  }
  function countUp(el) {
    if (el.__naoCounted) return;
    el.__naoCounted = true;
    var to = parseFloat(el.getAttribute('data-to'));
    if (isNaN(to)) return;
    var dec = parseInt(el.getAttribute('data-decimals') || '0', 10);
    var pre = el.getAttribute('data-prefix') || '';
    var suf = el.getAttribute('data-suffix') || '';
    var dur = parseInt(el.getAttribute('data-duration') || '1800', 10);
    if (reduce) { el.textContent = pre + fmt(to, dec) + suf; return; }
    var t0 = null;
    function step(t) {
      if (!t0) t0 = t;
      var p = Math.min((t - t0) / dur, 1);
      var e = 1 - Math.pow(1 - p, 4);
      el.textContent = pre + fmt(to * e, dec) + suf;
      if (p < 1) requestAnimationFrame(step);
    }
    el.textContent = pre + fmt(0, dec) + suf;
    requestAnimationFrame(step);
  }

  /* Turn existing theme numbers like "250 mg", "100%", "4.9/5", "753+" into count-ups */
  function autoCount(root) {
    var sel = cfg.autoCountSelector || 'main dl dt, main [class*="stat"] dt, main [class*="number"]';
    root.querySelectorAll(sel).forEach(function (el) {
      if (el.hasAttribute('data-to') || el.hasAttribute('data-count') || el.querySelector('[data-count]') || el.children.length) return;
      var m = el.textContent.trim().match(/^([^\d\-]*)(\d+(?:[.,]\d+)?)(.*)$/);
      if (!m || m[0].length > 16) return;
      var num = m[2].replace(',', '.');
      el.setAttribute('data-nao-count', '');
      el.setAttribute('data-to', num);
      el.setAttribute('data-prefix', m[1]);
      el.setAttribute('data-suffix', m[3]);
      el.setAttribute('data-decimals', (num.split('.')[1] || '').length);
    });
  }

  /* ---------- Reveal / bars / counters via one observer ---------- */
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (!en.isIntersecting) return;
      var el = en.target;
      el.classList.add('is-in');
      if (el.hasAttribute('data-nao-count')) countUp(el);
      el.querySelectorAll && el.querySelectorAll('[data-nao-count]').forEach(countUp);
      io.unobserve(el);
    });
  }, { rootMargin: '0px 0px -10% 0px', threshold: 0.12 }) : null;

  function observe(root) {
    root = root || document;
    if (cfg.autoCount !== false) autoCount(root);
    if (cfg.autoReveal) {
      root.querySelectorAll('main .shopify-section:not([id*="nao-"]) h2, main .shopify-section:not([id*="nao-"]) h3, main .shopify-section:not([id*="nao-"]) img, main .shopify-section:not([id*="nao-"]) article').forEach(function (el, i) {
        if (el.closest('[data-nao-reveal]') || el.closest('header') || el.closest('.nao-section')) return;
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight) return;
        el.classList.add('nao-auto-reveal');
        el.setAttribute('data-nao-reveal', '');
      });
    }
    var items = root.querySelectorAll('[data-nao-reveal], .nao-bar, [data-nao-count]');
    items.forEach(function (el) {
      var d = el.getAttribute('data-delay');
      if (d) el.style.setProperty('--nao-delay', d + 'ms');
      if (io && !reduce) io.observe(el);
      else { el.classList.add('is-in'); if (el.hasAttribute('data-nao-count')) countUp(el); }
    });
  }

  /* ---------- Parallax ---------- */
  var px = [];
  function collectParallax(root) {
    (root || document).querySelectorAll('[data-nao-parallax]').forEach(function (el) {
      if (px.indexOf(el) === -1) px.push(el);
    });
  }
  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      var vh = window.innerHeight;
      px.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.bottom < -100 || r.top > vh + 100) return;
        var speed = parseFloat(el.getAttribute('data-nao-parallax')) || 0.08;
        var center = r.top + r.height / 2 - vh / 2;
        var y = (-center * speed).toFixed(1);
        var base = el.getAttribute('data-nao-base') || '';
        el.style.transform = base + ' translate3d(0,' + y + 'px,0)';
      });
      ticking = false;
    });
  }

  /* ---------- Videos: play only when visible, respect data saver ---------- */
  function initVideos(root) {
    var saver = navigator.connection && navigator.connection.saveData;
    (root || document).querySelectorAll('video.nao-video').forEach(function (v) {
      if (saver || reduce) { v.removeAttribute('autoplay'); v.pause && v.pause(); return; }
      v.muted = true;
      if (!('IntersectionObserver' in window)) { v.play().catch(function () {}); return; }
      new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting) { v.play().catch(function () {}); } else { v.pause(); }
        });
      }, { threshold: 0.1 }).observe(v);
    });
  }

  /* ---------- Carousel ---------- */
  function initCarousels(root) {
    (root || document).querySelectorAll('[data-nao-carousel]').forEach(function (c) {
      if (c.__nao) return; c.__nao = true;
      var track = c.querySelector('.nao-carousel__track');
      var slides = Array.prototype.slice.call(track.children);
      var dotsWrap = c.querySelector('.nao-dots');
      var prev = c.querySelector('[data-prev]');
      var next = c.querySelector('[data-next]');
      var dots = [];
      function perView() {
        var w = slides[0] ? slides[0].getBoundingClientRect().width : 1;
        return Math.max(1, Math.round(track.clientWidth / w));
      }
      function pages() { return Math.max(1, slides.length - perView() + 1); }
      function current() {
        var w = slides[0].getBoundingClientRect().width + 16;
        return Math.round(track.scrollLeft / w);
      }
      function go(i) {
        i = Math.max(0, Math.min(i, slides.length - 1));
        track.scrollTo({ left: slides[i].offsetLeft - slides[0].offsetLeft, behavior: 'smooth' });
      }
      function buildDots() {
        if (!dotsWrap) return;
        dotsWrap.innerHTML = ''; dots = [];
        for (var i = 0; i < pages(); i++) {
          var b = document.createElement('button');
          b.type = 'button';
          b.setAttribute('aria-label', 'Go to review ' + (i + 1));
          (function (n) { b.addEventListener('click', function () { go(n); }); })(i);
          dotsWrap.appendChild(b); dots.push(b);
        }
        sync();
      }
      function sync() {
        var cur = current();
        dots.forEach(function (d, i) { d.setAttribute('aria-current', i === cur ? 'true' : 'false'); });
      }
      track.addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
      prev && prev.addEventListener('click', function () { go(current() - 1); });
      next && next.addEventListener('click', function () { go(current() + 1); });
      window.addEventListener('resize', buildDots);
      buildDots();
      var auto = parseInt(c.getAttribute('data-autoplay') || '0', 10);
      if (auto && !reduce) {
        var timer, paused = false;
        c.addEventListener('pointerenter', function () { paused = true; });
        c.addEventListener('pointerleave', function () { paused = false; });
        c.addEventListener('touchstart', function () { paused = true; }, { passive: true });
        timer = setInterval(function () {
          if (paused) return;
          var cur = current();
          go(cur + 1 >= pages() ? 0 : cur + 1);
        }, auto * 1000);
      }
    });
  }

  /* ---------- Compare switch (mobile) ---------- */
  function initCompare(root) {
    (root || document).querySelectorAll('[data-nao-compare]').forEach(function (c) {
      if (c.__nao) return; c.__nao = true;
      var btns = c.querySelectorAll('.nao-compare__switch button');
      function set(col) {
        c.querySelectorAll('[data-col]').forEach(function (cell) {
          cell.classList.toggle('is-active', cell.getAttribute('data-col') === col);
        });
        btns.forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-target') === col ? 'true' : 'false'); });
      }
      btns.forEach(function (b) { b.addEventListener('click', function () { set(b.getAttribute('data-target')); }); });
      if (btns[0]) set(btns[0].getAttribute('data-target'));
    });
  }

  /* ---------- Countdown ---------- */
  function initCountdowns(root) {
    (root || document).querySelectorAll('[data-nao-countdown]').forEach(function (el) {
      if (el.__nao) return; el.__nao = true;
      var end = new Date(el.getAttribute('data-nao-countdown')).getTime();
      if (isNaN(end)) return;
      var parts = { d: el.querySelector('[data-d]'), h: el.querySelector('[data-h]'), m: el.querySelector('[data-m]'), s: el.querySelector('[data-s]') };
      function pad(n) { return (n < 10 ? '0' : '') + n; }
      function tick() {
        var diff = Math.max(0, end - Date.now());
        var d = Math.floor(diff / 864e5), h = Math.floor(diff / 36e5) % 24, m = Math.floor(diff / 6e4) % 60, s = Math.floor(diff / 1e3) % 60;
        if (parts.d) parts.d.textContent = pad(d);
        if (parts.h) parts.h.textContent = pad(h);
        if (parts.m) parts.m.textContent = pad(m);
        if (parts.s) parts.s.textContent = pad(s);
        if (diff === 0) { clearInterval(iv); var done = el.closest('.nao-section'); done && done.classList.add('is-ended'); }
      }
      var iv = setInterval(tick, 1000); tick();
    });
  }

  /* ---------- Sticky CTA ---------- */
  function initSticky(root) {
    (root || document).querySelectorAll('[data-nao-sticky]').forEach(function (bar) {
      if (bar.__nao) return; bar.__nao = true;
      var offset = parseInt(bar.getAttribute('data-offset') || '600', 10);
      var mainBtn = document.querySelector('form[action*="/cart/add"] [type="submit"], form[action*="/cart/add"] button[name="add"]');
      var mainVisible = false;
      if (mainBtn && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (es) { mainVisible = es[0].isIntersecting; update(); }).observe(mainBtn);
      }
      var footer = document.querySelector('footer, .footer, #shopify-section-footer');
      var footerVisible = false;
      if (footer && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (es) { footerVisible = es[0].isIntersecting; update(); }).observe(footer);
      }
      function update() {
        var on = window.scrollY > offset && !mainVisible && !footerVisible;
        bar.classList.toggle('is-on', on);
        bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      }
      window.addEventListener('scroll', update, { passive: true });
      update();
      var trigger = bar.querySelector('[data-nao-atc]');
      if (trigger && mainBtn) {
        trigger.addEventListener('click', function (e) {
          e.preventDefault();
          mainBtn.click();
        });
      }
    });
  }

  function init(root) {
    observe(root);
    collectParallax(root);
    initVideos(root);
    initCarousels(root);
    initCompare(root);
    initCountdowns(root);
    initSticky(root);
    onScroll();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  if (!reduce) window.addEventListener('scroll', onScroll, { passive: true });

  /* Theme editor support */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
